var PlayerPage =  function() {
    const initPlayerDataToggle = function() {
        $('.ii__player-data-toggle').click(function(e) {
            const btn = $(e.currentTarget),
                btnInnerSpan = $(btn).find('span'),
                iSymbol = $(btn).find('i.icon'),
                iSymbolOpen = iSymbol.hasClass('fa-angle-up'),
                currentTxt = btnInnerSpan.text(),
                newTxt = currentTxt === 'Περισσότερα' ? 'Λιγότερα' : 'Περισσότερα',
                newClass = iSymbolOpen ? 'fa-angle-down' : 'fa-angle-up';
            btnInnerSpan.text(newTxt);
            iSymbol.removeClass('fa-angle-down fa-angle-up');
            iSymbol.addClass(newClass);
        });
    };

    const initLeagueSelector = function() {
        $('#league_selector').on('change', function() {
            loadLeagueData(this.value);
        });
    };

    const loadLeagueData = function(leagueId = 0) {
        Ajax.getPlayerData(
            PlayerPage.playerId,
            PlayerPage.activeSeason,
            PlayerPage.activeTeam,
            leagueId,
            (res) => {
                if (res.leagues_options) {
                    replaceLeaguesOptions(res.leagues_options);
                }
                if (res.table_html) {
                    replaceMatchesTable(res.table_html, res.hide_more);
                }
            }
        );
    };

    const replaceLeaguesOptions = function(newOptions) {
        const select = $('#league_selector');
        select.empty();
        select.append(newOptions);
    };

    const replaceMatchesTable = function(html, hideMore) {
        $('#player-matches-table > tbody').remove();
        $('#player-matches-table').append(html);
        $('#matches-more-btn').hide();
        if (!hideMore) {
            $('#matches-more-btn').show();
        }
    };

    const loadTeamData = function(element) {
        $(element).find('input').prop('checked', true);
        const splitId = $(element).find('input').prop('id').split('-');
        PlayerPage.activeTeam = splitId[2];
        PlayerPage.activeSeason = `${splitId[0]}/${splitId[1]}`;
        loadLeagueData();
    };

    return {
        init: function(playerId, teamId, season) {
            PlayerPage.activeTeam = teamId;
            PlayerPage.playerId = playerId;
            PlayerPage.activeSeason = season;
            $('.table--check tbody tr').on('click', function() {
                loadTeamData(this);
            });
            initPlayerDataToggle();
            initLeagueSelector();
        }
    };
}();
